import './App.css';
import './TotemTablet.css';
import AdCreative from './AdCreative';

function TotemTablet({
    creativeURL,
}) {
    return (
        <div
            className='totem-tablet'
            align='center'
        >
            <div className='totem-tablet-head'>
                <AdCreative
                    creativeURL={creativeURL}
                    creativeExt='mp4'
                    shouldAutoPlay={true}
                    hideControls={true}
                    isMuted={true}
                    height='100%'
                    width='100%'
                    objectFit='contain'
                />
            </div>
            <div className='totem-tablet-up' />
            <div className='totem-tablet-down' />
            <div className='totem-tablet-base' />
        </div>
    );
}

export default TotemTablet;